function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

if (window.location.search.includes('?cart') || window.location.search.includes('&cart')) {
  const cartDrawerV2 = document.querySelector('cart-drawer-v2');
  if (cartDrawerV2) {
    cartDrawerV2.open();
  } else {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      $('.slick-slider').not('.slick-initialized').slick();
      $('#cart-slider').slick('slickFilter', function (_, $el) {
        return !window.cartItems.includes(`${$el.dataset.productId}`)
      });
      const cartDrawerNote = cartDrawer.querySelector('[id^="Details-"] summary');
      if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) cartDrawer.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => {cartDrawer.classList.add('animate', 'active')});

      cartDrawer.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = cartDrawer.classList.contains('is-empty') ? cartDrawer.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
        const focusElement = cartDrawer.querySelector('.drawer__inner') || cartDrawer.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });

      document.body.classList.add('overflow-hidden');
    }
  }
}

const searchToggle = document.getElementById("searchToggle");
if (searchToggle) {
  searchToggle.addEventListener("click", function(){
    console.log('search Toggle click');
    const searchForm = document.querySelector('.search-modal__form');
    if (searchForm) searchForm.classList.toggle("collapsed");
  });
}

const mobileHeaderSearchTrigger = document.getElementById("mobileHeaderSearchTrigger");
if (mobileHeaderSearchTrigger) {
  mobileHeaderSearchTrigger.addEventListener("click", function(){
    const mobileSearch = document.querySelector('#mobileSearch');
    if (mobileSearch) mobileSearch.classList.add("open");
  });
}

const mobileSearchClose = document.getElementById("mobileSearchClose");
if (mobileSearchClose) {
  mobileSearchClose.addEventListener("click", function(){
    const mobileSearch = document.querySelector('#mobileSearch');
    if (mobileSearch) mobileSearch.classList.remove("open");
  });
}


$('#mobileHeaderSearchTrigger').click(() => {
  $('#mobileSearch')[0].classList.add('open');
  setTimeout(() => {
    $('#overlaySearch')[0].focus();
  }, 100);
});

$(document).on('click','#mobileMenuOpen',() => {
  $('#mobileMenu')[0].classList.add('open');
})
$('#mobileMenuClose').click(() => {
  $('#mobileMenu')[0].classList.remove('open');
})

$('#mobileSearchTrigger').click(() => {
  $('#mobileSearch')[0].classList.add('open');
  setTimeout(() => {
    $('#overlaySearch')[0].focus();
  }, 100);
})

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => {
        button.addEventListener('click', this.onButtonClick.bind(this))
      });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent)
      this.input.setAttribute('value', this.input.value)
    };
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

// Formats cents with the store's money format (window.moneyFormat), like Liquid's money filters.
// stripTrailingZeros mirrors money_without_trailing_zeros.
function formatShopMoney(cents, stripTrailingZeros = false) {
  const value = Number(cents) / 100;
  const format = window.moneyFormat || '${{amount}}';

  const formatNumber = (precision, thousands = ',', decimal = '.') => {
    if (stripTrailingZeros && value % 1 === 0) precision = 0;
    const [whole, fraction] = value.toFixed(precision).split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? grouped + decimal + fraction : grouped;
  };

  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
    switch (placeholder) {
      case 'amount_no_decimals': return formatNumber(0);
      case 'amount_with_comma_separator': return formatNumber(2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return formatNumber(0, '.', ',');
      case 'amount_with_apostrophe_separator': return formatNumber(2, "'", '.');
      case 'amount_no_decimals_with_space_separator': return formatNumber(0, ' ');
      case 'amount_with_space_separator': return formatNumber(2, ' ', ',');
      case 'amount_with_period_and_space_separator': return formatNumber(2, ' ', '.');
      default: return formatNumber(2);
    }
  });
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow-slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow-slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.productInfoRequestController = null;
    this.nativeButtonStates = new Map();
    this.purchaseButtonObserver = null;
    this.isRestoringPurchaseButton = false;
  }

  disconnectedCallback() {
    if (this.productInfoRequestController) this.productInfoRequestController.abort();
    if (this.purchaseButtonObserver) this.purchaseButtonObserver.disconnect();
  }

  onVariantChange(event) {

    this.updateOptions();
    this.updateMasterId();
    this.updateLowStockIndicator();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    const currentProductHandle = window.location.pathname.split('/')[2];  // Extracts handle from the URL
    // List of product handles where updateMedia should run
    const validProductHandles = ['gonorrhea-chlamydia-sti-kit-1-site','gonorrhea-chlamydia-sti-test-kit','gonorrhea-chlamydia-sti-test-kit', 'gonorrhea-chlamydia-hiv-syphilis', 'gonorrhea-chlamydia-hiv-syphilis-sti-test-kit-3-site'];  // Add other valid handles here

    // All other functions run for all products
    if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
    } else {
        // Keep the form's variant ID in sync before third-party scripts observe
        // the original swatch/select change event. The notification is sent
        // after the theme finishes rendering so apps such as Timesact get the
        // final pass over the purchase button.
        this.updateVariantInput(false);
        this.updateProductForm();

        // Dont call updateMedia for specific products
        if (!validProductHandles.includes(currentProductHandle)) {
            this.updateMedia(); 
        }

        if (this.dataset.context !== 'card-product') {
            this.updateURL();
            this.updateShareUrl();
        }

        // Notify integrations immediately as well as after the section fetch.
        // Timesact waits before reading the URL, so it will resolve the ID that
        // updateURL() just committed rather than retaining the previous variant.
        this.updateVariantInput(true);
        this.observePurchaseButton();
        
        this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateLowStockIndicator() {
    const indicator = this.querySelector('[data-stock-indicator]');
    const inventoryDataElement = this.querySelector('[data-low-stock-variants]');
    if (!indicator || !inventoryDataElement || !this.currentVariant) return;

    if (!this.lowStockVariantData) {
      this.lowStockVariantData = JSON.parse(inventoryDataElement.textContent);
    }

    const inventory = this.lowStockVariantData[String(this.currentVariant.id)];
    const isPreorder = this.dataset.isPreorder === 'true';
    const isExempt = this.dataset.oosExempt === 'true';
    const reserveApplies = this.dataset.oosLowStockEnabled === 'true' && !isExempt;
    const reserve = reserveApplies ? Number(this.dataset.oosLowStockThreshold || 0) : 0;
    const quantity = Number(inventory?.quantity || 0);
    const remaining = quantity - reserve;
    const shouldShow = Boolean(
      inventory &&
      inventory.available &&
      inventory.tracked &&
      !inventory.continueSelling &&
      !isPreorder &&
      quantity < 150 &&
      remaining > 0
    );

    indicator.hidden = !shouldShow;
    if (!shouldShow) return;

    indicator.dataset.stockLevel = quantity < 100 ? 'low' : 'medium';
    const message = indicator.querySelector('[data-stock-message]');
    if (message) {
      message.textContent = quantity <= 55 ? `Only ${remaining} left` : 'Low in stock';
    }
  }

  updateMedia() {
    console.log('updateMedia', this.currentVariant);
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    if (this.dataset.context === 'card-product') {
      const $img = $(`#ProductCard-${this.dataset.section}-${this.dataset.productId} img`)
      $img.attr('src', this.currentVariant.featured_image.src);
      $img.attr('alt', this.currentVariant.featured_image.alt);
      $img.attr('srcset', '')
      //featured_image
    } else {
      const mediaGallery = $(`#MediaGallery-${this.dataset.section} .slick-slider`);
      const mediaThumbnails = $(`#pdpThumbnails`);
      const mediaGallerySlides = $(`#MediaGallery-${this.dataset.section} .slick-slider .slide`);
      const mediaId = this.dataset.section + '-' + this.currentVariant.featured_media.id

      $('#selectedOption').text(this.currentVariant.title)

      const sanitizedTitle = this.currentVariant.title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
      mediaGallery.attr('data-selected-variant', sanitizedTitle)

      console.log('sanitizedTitle',sanitizedTitle);

      const filterKey = '.variant-' + sanitizedTitle;

      mediaGallery.slick('slickUnfilter')
      const matchingSlides = $(
        `#MediaGallery-${this.dataset.section} #pdpImages .slide${filterKey}:not(.slick-cloned)`
      ).length;

      if (matchingSlides > 0) {
        mediaGallery.slick('slickFilter', filterKey).slick('refresh')
      } else {
        console.warn('No media matched current variant, keeping gallery unfiltered', {
          variantTitle: this.currentVariant.title,
          sanitizedTitle
        });
        mediaGallery.slick('refresh')
      }
      
      // .slick('slickGoTo', 0)
      // mediaGallery.slick('slickGoTo', 0)
      let newSlideCount = $('#pdpThumbnails .slide.variant-' + sanitizedTitle + ':not(.slick-cloned)').length
      if (!newSlideCount) {
        newSlideCount = $('#pdpThumbnails .slide:not(.slick-cloned)').length
      }
      if (newSlideCount && newSlideCount > 10) {
        newSlideCount = 10
      }
      mediaThumbnails.css({ '--slide-count': newSlideCount });
      // mediaThumbnails.slick({ slidesToShow: newSlideCount }).slick('refresh');

      const currentSlideIndex = mediaGallery.find(`[data-media-id='${ mediaId }']`).index()

      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateProductForm() {

    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

    console.log('updateProductForm, this.currentVariant', this.currentVariant);
    let currentVariantId = this.currentVariant.id;
    let productForm = $(this).parent()[0].querySelector('product-form');
    if (this.dataset.context !== 'card-product') {
    } else {
      productForm = $(this).parent().parent()[0];
    }
    productForm.setAttribute('data-current-variant', this.currentVariant.id);

    $('*[class^="variant-checked-"]').each((index, item) => {
      $(item).prop('checked', false);
    });

    $('*[class^="variant-show-"]').addClass('hidden')
    $(productForm).removeClass('has-preorder')

    $('*[class^="variant-show-"]').each((index, item) => {

      console.log('currentVariant Object', this.currentVariant);
      console.log('currentVariantId', this.currentVariant.id);
      console.log('currentVariant compare_at_price', this.currentVariant.compare_at_price);
      console.log('item classList', item.classList);

      if (item.classList.toString().includes(this.currentVariant.id)) {
        console.log('productForm add has-preorder', productForm);
        $(item).removeClass('hidden');
        $(productForm).not('[data-context="cart-quick-add"]').addClass('has-preorder');
      }
      //  else {
      //   $(item).addClass('hidden');
      //   $(productForm).removeClass('has-preorder');
      // }
    })

    let productPriceDisplay = "$ " + this.currentVariant.price / 100;
    const comparePriceCSSClasses = 'strike-price relative inline-block mr-1';

    if (this.currentVariant.compare_at_price) {
      let productComparePriceDisplay = "$" + this.currentVariant.compare_at_price / 100;
      let discountAmountMoney = "$" + (this.currentVariant.compare_at_price - this.currentVariant.price) / 100;
      let difference = (this.currentVariant.compare_at_price - this.currentVariant.price) / 100
      
      if (difference > 0) {
    //     console.log('diff', difference)
        $(productForm).find('.price__container .price__wrap').removeClass('price__regular').addClass('price__sale');
        $(document).find('.product .product-discount-amount span').text('Save ' + discountAmountMoney);
        $(document).find('.product .product-discount-amount').removeClass('hidden');
      } else { // If savings are not present, remove 'Save $X' text
        $(document).find('.product .product-discount-amount').addClass('hidden');
      }

    //   if (!$(productForm).find('.price__container .price__wrap .price-item--sale').length) {
    //     $(productForm).find('.price__container .price__wrap').append(`<span class="price-item price-item--sale price-item--last inline-block"></span>`);
    //   }

    //   $(document).find('.price__container .price-item.price-item--regular').text(productComparePriceDisplay).addClass(comparePriceCSSClasses);
    //   $(document).find('[id*="MainProduct"] product-form .price__container .price-item.price-item--sale').text(productPriceDisplay).removeClass('hidden');

    // } else {
    //   $(document).find('.price__container .price__wrap').addClass('price__regular').removeClass('price__sale');
    //   $(document).find('.product .product-discount-amount').addClass('hidden');
    //   $(document).find('.price__container .price-item.price-item--sale').addClass('hidden');
    //   $(document).find('[id*="MainProduct"] product-form .price__container .price-item.price-item--regular').text(productPriceDisplay).removeClass(comparePriceCSSClasses)
    }

  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput(dispatchChange = true) {
    
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #quick-add-${this.dataset.productId}, #quick-add-slide-${this.dataset.productId}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = this.currentVariant.id;
      if (dispatchChange) {
        input.dispatchEvent(new Event('change', { bubbles: true }));

        // Timesact only binds its variant listener to radio/select controls
        // inside the product form. Our visible swatches live outside the form
        // and reference it with the `form` attribute, so notify its in-form
        // compatibility proxy as well.
        const variantChangeProxy = productForm.querySelector('[data-variant-change-proxy]');
        if (variantChangeProxy) {
          variantChangeProxy.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm && productForm.handleErrorMessage) productForm.handleErrorMessage();
  }

  variantHasSellingPlan(variant = this.currentVariant) {
    return Boolean(variant?.selling_plan_allocations?.length);
  }

  observePurchaseButton() {
    if (this.dataset.context === 'card-product' || this.purchaseButtonObserver) return;

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = productForm?.querySelector('[name="add"].native-add-button');
    if (!addButton) return;

    this.purchaseButtonObserver = new MutationObserver(() => {
      this.restoreNativePurchaseButton();
    });
    this.purchaseButtonObserver.observe(addButton, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  restoreNativePurchaseButton() {
    if (this.isRestoringPurchaseButton || !this.currentVariant || this.variantHasSellingPlan()) return;

    const variantId = String(this.currentVariant.id);
    const nativeState = this.nativeButtonStates.get(variantId);
    if (!nativeState) return;

    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productFormComponent = productForm?.closest('product-form');
    const addButton = productForm?.querySelector('[name="add"].native-add-button');
    if (!productForm || !addButton || productFormComponent?.classList.contains('has-preorder')) return;

    const hasStaleTimesactFields = Boolean(
      productForm.querySelector('[data-timesact-selling-plan], #preorder-label, #timesact-widget, .timesact-preorder-description, .timesact-selling-plan-description')
    );
    const hasPreorderText =
      !addButton.querySelector('.preorder-show') && /pre[\s-]?order/i.test(addButton.textContent || '');
    const lostNativePrice = nativeState.hasPrice && !addButton.querySelector('.price');
    if (!hasStaleTimesactFields && !hasPreorderText && !lostNativePrice) return;

    this.isRestoringPurchaseButton = true;
    addButton.innerHTML = nativeState.innerHTML;
    addButton.toggleAttribute('disabled', nativeState.disabled);
    productForm
      .querySelectorAll('[data-timesact-selling-plan], #preorder-label, #timesact-widget, .timesact-preorder-description, .timesact-selling-plan-description')
      .forEach((element) => element.remove());
    this.toggleAddButton(nativeState.disabled, window.variantStrings.soldOut, true, this.currentVariant.price);
    this.isRestoringPurchaseButton = false;
  }

  renderProductInfo() {
    const requestedVariant = this.currentVariant;
    const requestedVariantId = String(requestedVariant.id);

    if (this.productInfoRequestController) this.productInfoRequestController.abort();
    this.productInfoRequestController = new AbortController();
    const requestController = this.productInfoRequestController;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`, {
      signal: requestController.signal
    })
      .then((response) => response.text())
      .then((responseText) => {
        // A slower response for a previously selected variant must never
        // overwrite the currently selected variant's price or button state.
        if (requestController.signal.aborted || String(this.currentVariant?.id) !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
        const sourceProductInfo = html.getElementById(
          `ProductInfo-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const visiblePrice = productInfo?.querySelector('[data-variant-price]');
        const sourceVisiblePrice = sourceProductInfo?.querySelector('[data-variant-price]');
        if (visiblePrice && sourceVisiblePrice) {
          visiblePrice.innerHTML = sourceVisiblePrice.innerHTML;
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        // Read button disabled state from the server-rendered HTML (Liquid already computed pdp_is_sold_out correctly).
        // Avoids relying on inventory_quantity which is not reliably available in product.variants | json.
        const serverButton = html.querySelector('[name="add"].native-add-button');
        const isSoldOut = serverButton ? serverButton.hasAttribute('disabled') : !requestedVariant.available;
        if (serverButton) {
          this.nativeButtonStates.set(requestedVariantId, {
            innerHTML: serverButton.innerHTML,
            disabled: isSoldOut,
            hasPrice: Boolean(serverButton.querySelector('.price'))
          });
        }
        this.toggleAddButton(isSoldOut, window.variantStrings.soldOut, true, requestedVariant.price);
        this.restoreNativePurchaseButton();

      })
      .catch((error) => {
        if (error.name !== 'AbortError') console.error('Unable to update product information', error);
      })
      .finally(() => {
        if (this.productInfoRequestController === requestController) {
          // The theme has now completed its final DOM update. Notify integrations
          // afterwards so their variant-specific state cannot be overwritten by
          // this request. This also runs after non-abort fetch failures.
          if (!requestController.signal.aborted && String(this.currentVariant?.id) === requestedVariantId) {
            this.updateVariantInput(true);
          }
          this.productInfoRequestController = null;
        }
      });
  }
/*
  toggleAddButton(disable = true, text, modifyClass = true, price = null) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const OOSMessage = document.getElementById('OOS-message');
    if (!addButton) return;
    let buttonText = text;
    if (!disable && price) {
        const sectionEl = document.getElementById(`ProductInfo-${this.dataset.section}`);
        const buttonDiscountEnabled = sectionEl?.dataset?.visualDiscountButtonEnabled === 'true';
        const noVisualDiscount = sectionEl?.dataset?.noVisualDiscount === 'true';
        const discountPercent = Number(sectionEl?.dataset?.visualDiscountPercent || 0);

        let displayPrice = price;
        if (buttonDiscountEnabled && !noVisualDiscount && discountPercent > 0) {
          const multiplier = (100 - discountPercent) / 100;
          displayPrice = Math.round(price * multiplier);
        }

        buttonText = `Add to Cart - $${(displayPrice / 100).toFixed(2)}`;
    }
    if (disable && !document.querySelector('product-form').classList.contains('has-preorder')) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = buttonText;
        if (OOSMessage) {
            OOSMessage.style.visibility = 'visible';
        }
    } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = buttonText; 
        if (OOSMessage) {
            OOSMessage.style.visibility = 'hidden';
        }
    }
    if (!modifyClass) return;
  }
*/

/* striked price inject to add to cart button on pdp */

toggleAddButton(disable = true, text, modifyClass = true, price = null) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const OOSMessage = document.getElementById('OOS-message');
    if (!addButton) return;
    let buttonText = text;
    if (!disable && price) {
        const sectionEl = document.getElementById(`ProductInfo-${this.dataset.section}`);
        const buttonDiscountEnabled = sectionEl?.dataset?.visualDiscountButtonEnabled === 'true';
        const noVisualDiscount = sectionEl?.dataset?.noVisualDiscount === 'true';
        const discountPercent = Number(sectionEl?.dataset?.visualDiscountPercent || 0);

        let displayPrice = price;
        let displayCompare = null;
        const compareAt = this.currentVariant?.compare_at_price;

        if (compareAt && compareAt > price) {
          displayCompare = compareAt;
        } else if (buttonDiscountEnabled && !noVisualDiscount && discountPercent > 0) {
          const multiplier = (100 - discountPercent) / 100;
          displayPrice = Math.round(price * multiplier);
          displayCompare = price;
        }

        const priceContainer = addButton.querySelector('.price');
        if (priceContainer) {
          const money = (cents) => formatShopMoney(cents);
          if (displayCompare) {
            priceContainer.innerHTML = `
              <div class="price__container">
                <div class="price__wrap price__sale">
                  <span class="hidden">Regular price</span>
                  <span>
                    <s class="price-item price-item--regular strike-price relative inline-block mr-1">${money(displayCompare)}</s>
                  </span>
                  <span class="hidden">Sale price</span>
                  <span class="price-item price-item--sale price-item--last inline-block" data-product-id="${this.dataset.productId}">${money(displayPrice)}</span>
                </div>
              </div>
            `;
          } else {
            priceContainer.innerHTML = `
              <div class="price__container">
                <div class="price__wrap price__regular">
                  <span class="hidden">Regular price</span>
                  <span class="price-item price-item--regular" data-product-id="${this.dataset.productId}">${money(displayPrice)}</span>
                </div>
              </div>
            `;
          }
          buttonText = null;
        } else if (addButton.hasAttribute('data-hide-price') || addButton.closest('.gummies-pdp')) {
          // Label-only button: keep the wording, never append the price
          buttonText = disable ? text : window.variantStrings.addToCart;
        } else {
          buttonText = `Add to Cart - ${formatShopMoney(displayPrice)}`;
        }
    }
    if (disable && !productForm.closest('product-form')?.classList.contains('has-preorder')) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = buttonText;
        if (OOSMessage) {
            OOSMessage.style.visibility = 'visible';
        }
    } else {
        addButton.removeAttribute('disabled');
        if (buttonText) addButtonText.textContent = buttonText; 
        if (OOSMessage) {
            OOSMessage.style.visibility = 'hidden';
        }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    
    fieldsets.forEach(fieldSet => {
      // Set all radios inactive
      Array.from(fieldSet.querySelectorAll('input')).forEach(el => el.removeAttribute('checked'))
      // Set radios active when value is an active option
      Array.from(fieldSet.querySelectorAll('input')).forEach(el => {
        if (this.options.includes(el.value)) $(el).attr('checked','checked');
      });
    })
  }
}

customElements.define('variant-radios', VariantRadios);

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.context = this.dataset.context || null;
        this.form = this.querySelector('form');
        //console.log('this.form', this.form);
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer-v2') || document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.qty = document.querySelector('quantity-input.pdp-quantity input');
        this.submitButton = this.querySelector('[type="submit"]');
        this.loadingSpinner = this.context === 'cart-quick-add' ? this.querySelector('.cart-quick-add__spinner') : this.querySelector('.loading-overlay__spinner')
        this.quickAdd = this.context === 'cart-quick-add' ? this.querySelector('.cart-quick-add__add') : null
        this.bundleItems = this.dataset.bundle || null
        this.bundleName = this.dataset.bundleName || null

        if( $('*[class^="variant-show-"]').length){
          if($('*[class^="variant-show-"]').parents('[id*="ProductInfo-template-"]').length){
            $('*[class^="variant-show-"]').removeClass('hidden');
            $('product-form').addClass('has-preorder');
          }
        }
        
        if (document.querySelector('cart-drawer-v2') || document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

      }

      onSubmitHandler(evt) {
        //console.log('onSubmitHandler this', this);
        //console.log('dataLayer', JSON.stringify(dataLayer));
        const qty = this.qty?.getAttribute('value') || 1;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove('hidden');
        }

        if (this.quickAdd) {
          this.quickAdd.classList.add('hidden');
        }
        
        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

      
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map(section => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // console.log('Form Data:', formData);
        // console.log('Form Config:', config);
        // console.log('routes.cart_add_url:', routes.cart_add_url);

        if (this.bundleItems !== null) {
          const bundleItemIds = this.bundleItems.split(',');
          var bundleName = this.bundleName;

          const itemArray = [];
          bundleItemIds.forEach(item => {
            itemArray.push({
              id: item,
              quantity: qty,
              properties: { 'bundle': bundleName }
            });
          });

          let bodyData = {
            items: itemArray,
            sections: this.cart.getSectionsToRender().map(section => section.id),
            sections_url: window.location.pathname
          };

          config = fetchConfig('json');
          config.body = JSON.stringify(bodyData);

          ///
          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
              if (response.product_id) {
                if (window.cartItems.includes(response.product_id) === false) {
                    window.cartItems = [...window.cartItems, `${response.product_id}`]
                }
              }
              
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  {once: true},
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty'))
                this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              
              if (this.loadingSpinner) {
                this.loadingSpinner.classList.add('hidden');
              }
      
              if (this.quickAdd) {
                this.quickAdd.classList.remove('hidden');
              }
            });
          ///
        } else {
          fetch(`${routes.cart_add_url}`, config)
            .then(response => response.json())
            .then(response => {
              if (response.product_id) {
                if (window.cartItems.includes(response.product_id) === false) {
                    window.cartItems = [...window.cartItems, `${response.product_id}`]
                }
              }
              
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButton.querySelector('span').classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  {once: true},
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty'))
                this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              
              if (this.loadingSpinner) {
                this.loadingSpinner.classList.add('hidden');
              }
      
              if (this.quickAdd) {
                this.quickAdd.classList.remove('hidden');
              }
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

//slideshows.js
// Slideshow Events
$('.slick-slider.progress-dots').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
  $(this).css({ '--progress': nextSlide });
});

$('.slick-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
	if ($(this).parent().closest('#currentSlide')) {
		const currentSlide = $(this).parent().find('#currentSlide')[0];
		$(currentSlide).text(nextSlide + 1);
	}
});

$('.slick-slider').on('init', function(event, slick) {
	if ($(this).parent().closest('#slideCount')) {
		const currentSlide = $(this).parent().find('#slideCount')[0];
		$(currentSlide).text(slick.slideCount);
	}
});

$(document).ready(function(){
	$('.slick-slider').not('.slick-initialized').slick();

	// Accordions
	$.fn.slideFadeToggle  = function(opacity = 'toggle', height = 'toggle', speed = 200, callback, easing) {
	  return this.animate({opacity: opacity, height: height}, speed, easing, callback);
	};
	$(".accordion:not(.pdp-accordion) .accordion-content:not(.open)").hide();

	if($('.pdp-accordion-content').innerHeight() > 300){
		$('.pdp-accordion-content').addClass('accordion-height-toggle maximum-height');
	}

	$('.pdp-accordion-content .accordions-toggle').click(function(){
		$('.pdp-accordion-content').toggleClass('maximum-height');
		if( $('.pdp-accordion-content').hasClass('maximum-height' )){
			$(this).html('+ See More');
		}else{
			$(this).html('- See Less');
		}
	})
  
	$('.pdp-accordion-content .accordion-header').click(function(){
		$(this).toggleClass('open');
    });

   var tglHandle = $(".accordion:not(.pdp-accordion) .accordion-header");
	tglHandle.click(function() {
		if ($(this).hasClass('collapse-other')) {
			const accordionSet = $(this).parent().parent()
			if ($(this).hasClass('open')) {
				// console.log('close self');
				$(this).removeClass("open");
				$(this).next(".accordion .accordion-content").removeClass("open").slideFadeToggle();
			} else {
				// console.log('open self + close open item');
				accordionSet.find(".accordion-header.open").each((index, item) => {
					$(item).removeClass("open");
					$(item).next(".accordion .accordion-content").slideFadeToggle();
				})
				$(this).addClass("open");
				$(this).next(".accordion .accordion-content").slideFadeToggle();
			}
		} else {
	  	$(this).next(".accordion .accordion-content").slideFadeToggle();
		  $(this).next(".accordion .accordion-content").toggleClass("open");
	  	$(this).toggleClass("open");
		}
	});
});

window.lazyload = function() {};

// DAME11 - V4
document.addEventListener("DOMContentLoaded", function() {
  // Replace the "FILTER BY:" label
  let filterLabel = document.querySelector(".filter-wrapper label");
  if (filterLabel) {
      let filterIcon = document.createElement("img");
      filterIcon.src = "https://cdn.shopify.com/s/files/1/1027/2873/files/DAME11-filter-icon.svg?v=1739956329";
      filterIcon.alt = "Filter";
      filterLabel.replaceWith(filterIcon);
  }

  // Replace the "SORT BY:" label
  let sortLabel = document.querySelector("#new-filter-sort-sort-options label");
  if (sortLabel) {
      let sortIcon = document.createElement("img");
      sortIcon.src = "https://cdn.shopify.com/s/files/1/1027/2873/files/DAME11-featured-icon.svg?v=1739956330";
      sortIcon.alt = "Sort";
      sortLabel.replaceWith(sortIcon);
  }
});

// DAME16 - PDP Redesign - closing details accordions
document.addEventListener("DOMContentLoaded", function () {
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach(header => {
      header.classList.remove("open"); // Remove the 'open' class on page load
  });
});

// DAME16 - Bestseller label showing on 1st image
document.addEventListener("DOMContentLoaded", function() {
  const slider = document.getElementById("pdpImages");
  if (!slider) return;

  let lastIndex = null;

  function updateLabel() {
    // Find the currently active slide (Slick sets aria-hidden="false" on active slide)
    const activeSlide = slider.querySelector(".slick-slide[aria-hidden='false']");
    if (activeSlide) {
      const currentIndex = activeSlide.getAttribute("data-slick-index");
      if (currentIndex !== lastIndex) {
        // Hide all labels on all slides
        slider.querySelectorAll(".dame16-label").forEach(label => {
          label.style.display = "none";
        });
        // If the active slide has data-slick-index="0", show its label
        if (currentIndex === "0") {
          const label = activeSlide.querySelector(".dame16-label");
          if (label) {
            label.style.display = "block";
          }
        }
        lastIndex = currentIndex;
      }
    }
    // Check again on the next animation frame
    requestAnimationFrame(updateLabel);
  }

  // Start the animation frame loop
  requestAnimationFrame(updateLabel);
});

// FAQs on PDPs via metafields
document.addEventListener('DOMContentLoaded', function() {
  const accordionButtons = document.querySelectorAll('#custom-faq .faq-question button');
  
  accordionButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      // Toggle the expanded state on click
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
      
      // Toggle the answer visibility
      const answerId = this.getAttribute('aria-controls');
      const answerElement = document.getElementById(answerId);
      if (!expanded) {
        answerElement.removeAttribute('hidden');
      } else {
        answerElement.setAttribute('hidden', '');
      }
    });
  });
});


// DAME15 SEARCH ICON TOGGLES SEARCH FORM
document.addEventListener('DOMContentLoaded', function() {
    const searchToggle = document.getElementById('searchToggle');
    const searchForm = document.getElementById('searchForm');
    const searchInput = searchForm.querySelector('input.search__input.field__input');

    searchToggle.addEventListener('click', function() {
        searchForm.classList.toggle('collapsed');
        
        // Focus input when opening (when collapsed class is removed)
        if (!searchForm.classList.contains('collapsed')) {
            searchInput.focus();
        }
    });
});



// rebuy verbiage button update on preoder
(function () {
  function patch() {
    document
      .querySelectorAll('.rebuy-product-block.tag-preorder button.rebuy-button span')
      .forEach(span => { span.textContent = 'Pre-order'; });
  }

  // Run now + a few delayed runs (covers async Rebuy render)
  patch();
  setTimeout(patch, 300);
  setTimeout(patch, 1000);
  setTimeout(patch, 2500);
})();
